import React from 'react';
import { motion } from 'framer-motion';
import { ProcessedQuote } from '@/types';

interface QuoteCardProps {
  quote: ProcessedQuote;
  isLoading?: boolean;
}

export const QuoteCard: React.FC<QuoteCardProps> = ({ quote, isLoading = false }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.4 }}
      className="container max-w-4xl mx-auto"
    >
      <div className="bg-black bg-opacity-20 backdrop-blur-xl border border-white border-opacity-20 rounded-3xl p-8 md:p-12 text-center">
        {isLoading ? (
          <div className="animate-pulse">
            <div className="h-8 bg-white bg-opacity-20 rounded mb-6"></div>
            <div className="h-6 bg-white bg-opacity-15 rounded w-3/4 mx-auto"></div>
          </div>
        ) : (
          <>
            {/* Quote Text */}
            <motion.blockquote
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              className="text-white text-xl md:text-2xl lg:text-3xl leading-relaxed mb-6 font-light"
              style={{
                textShadow: '0 2px 20px rgba(0, 0, 0, 0.5), 0 0 40px rgba(0, 0, 0, 0.3)'
              }}
            >
              {quote.text}
            </motion.blockquote>
            
            {/* Quote Source */}
            <motion.cite
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.8 }}
              className="text-white text-base md:text-lg opacity-80 not-italic"
              style={{
                textShadow: '0 2px 20px rgba(0, 0, 0, 0.5), 0 0 40px rgba(0, 0, 0, 0.3)'
              }}
            >
              —— {quote.source}
            </motion.cite>
          </>
        )}
      </div>
    </motion.div>
  );
};